export const LogoMark = ({ className = "w-9 h-9" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <rect width="64" height="64" rx="15" fill="#0B1F3A" />
    <path
      d="M13 14h6.4v13.2c1.9-2.2 4.6-3.4 7.8-3.4 6.4 0 10.8 5 10.8 12.1S33.6 48 27.2 48c-3.2 0-5.9-1.2-7.8-3.4V48H13V14zm12.7 15.6c-3.8 0-6.4 2.8-6.4 6.3s2.6 6.4 6.4 6.4 6.4-2.8 6.4-6.4-2.6-6.3-6.4-6.3z"
      fill="#fff"
    />
    <circle cx="46.5" cy="44" r="4.6" fill="#2DD4BF" />
  </svg>
);

export const Wordmark = () => (
  <span className="flex items-center gap-2.5">
    <LogoMark className="w-9 h-9 ring-1 ring-white/10 rounded-[10px]" />
    <span className="text-[17px] font-bold tracking-tight leading-none">
      bsys<span className="text-[#2DD4BF]">.</span>
    </span>
  </span>
);
